
// import { checkUrl } from '@/utils/helper';
// import Link from '@/utils/link';
// import Image from '@components/cards/image';
import { isEmpty, map } from 'lodash';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { BsTwitterX } from 'react-icons/bs';
import { EmailIcon, EmailShareButton, FacebookIcon, FacebookShareButton, TwitterShareButton } from 'react-share';
import DynamicAds, { KEY_ADS_POSITION } from 'src/components/ads/dynamic-ads';
import { APP_IMG, APP_URL } from 'src/constants';
import { DATALAYER_TYPE, sendDataLayerGlobal, sendDataMeta } from 'src/utils/datalayer/send-datalayer';
import { useResponsive } from 'src/utils/device';
import { checkUrl } from 'src/utils/helper';
import styled from 'styled-components';
import CardV from '../cards/card-v';
import HeadingTag, { KEY_HEADING_TAG } from '../heading/heading-tag';
import Image from '../image';

// const WidgetAdsIndex = dynamic(
//   () => import('@components/widgets/widget-ads-index'),
//   { ssr: false }
// );
// const CardV = dynamic(() => import('@components/cards/card-v'));

const GalleryDefault = (data) => {
  const { article, lastNews, ads, nextLink } = data;

  const router = useRouter();
  const [parsedLink, setParsedLink] = useState(null);
  const [loadData, setLoadData] = useState(lastNews?.slice(0, 3));
  const [showLoading, setShowLoading] = useState(false);
  const [newArticle, setNewArticle] = useState(null);

  const dataGallery = article?.data ?? [];
  const shareLink = `${APP_URL}`;
  const responsive = useResponsive();
  const SOCIAL_SHARE = [
    {
      id: 1,
      name: 'facebook',
      icon: (
        <FacebookShareButton url={shareLink}>
          <FacebookIcon size={36} round={true} />
        </FacebookShareButton>
      )
    },
    {
      id: 2,
      name: 'x',
      icon: (
        <TwitterShareButton url={shareLink}>
          <div className='x-sticky-wrapper'>
            <BsTwitterX />
          </div>
        </TwitterShareButton>
      )
    },
    {
      id: 3,
      name: 'email',
      icon: (
        <EmailShareButton url={shareLink}>
          <EmailIcon size={36} round={true} />
        </EmailShareButton>
      )
    }
  ];
  const chunkSizes = responsive?.isMobile ? [3, 3, 3, 3] : [4, 4, 4, 4];
  let startIndex = 0;
  const [closeAd, setCloseBoxAd] = useState(true);

  const handleCloseBoxAd = () => {
    setCloseBoxAd(false);
  };
  useEffect(() => {
    try {
      if (lastNews?.length > 4) {
        setShowLoading(true);
      }
      const articleData = localStorage.getItem('article-data');
      if (articleData) {
        const data = JSON.parse(articleData ?? '');
        const _link = data.link;
        setNewArticle(data);
        setParsedLink(_link);
      }
    } catch (error) {

    }
  }, []);

  const handleOpen = (item, i) => {
    try {
      // ! DATALAYER
      sendDataMeta({
        id: `อัลบั้ม : ${article?.title} | ${item.id}`,
        category: 'อัลบั้มภาพ',
        author: `${article?.created_by ?? ''}`,
        keyword: `${article?.tags}`,
        createdAt: `${article?.created_at}`
      });
      sendDataLayerGlobal({
        type: DATALAYER_TYPE.TRACK_POSITION,
        router: router?.pathname,
        section: 'section-category',
        position: 'ใต้:ads-billboard',
        data: {
          block: '1',
          title: `${item.id}`,
          heading: 'อัลบั้มล่าสุด',
          index: i + 1
        }
      });
      const _pathname = checkUrl(router?.asPath) ? router?.asPath : '';
      // console.log('#1', nextLink);
      // const currentPath = window.location.pathname;
      localStorage.setItem(
        'article-data',
        JSON.stringify({
          title: article.title,
          link: '',
          author: `${newArticle?.author ?? ''}`,
          group: article.id,
          galleriesLink: _pathname
        })
      );
      localStorage.setItem('preview', JSON.stringify(item.id));

      router.push(nextLink ?? `${router.asPath}/${item.id}`);
    } catch (error) {
      console.log('Error: Please enable website cookies. ' + error);
    }
  };
  const handleLoad = () => {
    setLoadData(lastNews?.slice(0, 6));
    setShowLoading(false);
  };
  // console.log({ ads });

  return (
    <>
      <GalleriesWrapper id='category-1' className='main-content'>
        <DynamicAds position={KEY_ADS_POSITION.BILLBOARD} data={ads} />

        <div id='section-category' className='container-content grid-wrapper  '>
          <div id='block-1' className='album'>
            <h1> {`อัลบั้มรูป ${article.title}`} </h1>
            <div className='desc'>
              <h2> {`รวมทั้งหมด ${dataGallery.length} ภาพ`} </h2>
              {parsedLink &&
                <a className='btn-articles' href={parsedLink}>
                  อ่านเรื่องนี้
                </a>
              }
            </div>
            {/* <WidgetHeader headingText={`รวมอัลบั้มรูป`} imgSrc={`${APP_IMG}/images/3.0/header-blue.webp`} /> */}
            <div className='responsive-container-block bg'>
              {!isEmpty(dataGallery) &&
                chunkSizes.map((size, index) => {
                  const chunkedData = dataGallery.slice(
                    startIndex,
                    startIndex + size
                  );
                  startIndex += size;
                  return (
                    <div key={index} className='responsive-image'>
                      {map(chunkedData, (item, i) => (
                        <div
                          key={item.id}
                          className='img-wrapper'
                          onClick={() => handleOpen(item, i)}
                        >
                          <Image
                            external={true}
                            className={`img ${size === 2 ? 'img-big' : ''}`}
                            image={`${APP_IMG}${item.file}`}
                            alt={item?.id}
                          />
                        </div>
                      ))}
                    </div>
                  );
                })}
            </div>
            <div id='widget-share' className='share-grid'>
              <div className='text-topic'> แชร์ </div>
              {SOCIAL_SHARE.map((item, index) => (
                <div className='share item' key={index}>
                  <div
                    key={index}
                    className={`icon-${item.name}`}
                    // ! DATALAYER
                    onClick={() =>
                      sendDataLayerGlobal({
                        type: DATALAYER_TYPE.TRACK_INDEX,
                        router: router?.pathname,
                        section: 'section-content',
                        position: 'ใต้:หัวข้ออัลบั้ม',
                        data: {
                          block: '2',
                          title: item.name,
                          heading: 'แชร์อัลบั้ม',
                          index: index + 1
                        }
                      })
                    }
                  >
                    {item.icon}
                  </div>
                </div>
              ))}
            </div>
            {loadData && Array.isArray(loadData) && loadData.length > 0 && (
              <div className='widget-lasted container'>
                <div className='section-title'>
                  <HeadingTag
                    heading={'อัลบั้มล่าสุด'}
                    type={KEY_HEADING_TAG.SECTION_SECTION}
                    path={null}
                  />
                </div>
                {/* <WidgetHeader
                  headingText={'อัลบั้มล่าสุด'}
                  imgSrc={`${APP_IMG}/images/3.0/header-blue.webp`}
                  eventDataLayer={null}
                /> */}
                <div id='block-2' className='galleries-lastnews'>
                  {/* <Carousels slideShow={3} autoplay={true} infinite={true}> */}
                  {loadData.map((item, i) => (
                    <div key={i} className='card-main'>
                      <CardV
                        external={false}
                        showFooter={false}
                        path={`/galleries/${item.id}`}
                        data={{
                          ...item,
                          // image: loadData[0].image ?? item.data?.[0]?.file,
                          link: `/galleries/${item.id}`
                        }}
                        // ! DATALAYER
                        eventDataLayer={{
                          type: DATALAYER_TYPE.TRACK_POSITION,
                          router: router?.pathname,
                          section: 'section-category',
                          position: 'ใต้:ads-billboard',
                          data: {
                            block: '2',
                            title: `${item.title}`,
                            heading: 'อัลบั้มล่าสุด',
                            index: i + 1
                          }
                        }}
                      />
                    </div>
                  ))}
                  {/* </Carousels> */}
                </div>
                <div className='flex-center'>

                  {(showLoading) && <div className='btn-articles' onClick={() => handleLoad()}>
                    ดูเพิ่มเติม
                  </div>}
                  <div className='btn-articles'>
                    <a
                      href='/galleries'
                      className='link-article'
                      onClick={() => {
                        sendDataMeta({
                          id: `อัลบั้ม : ${data?.article?.title}`,
                          category: 'อัลบั้มภาพ',
                          author: article?.created_by,
                          keyword: `${data?.article.tags}`,
                          createdAt: `${data?.article.created_at}`
                        });
                        // ! DATALAYER
                        sendDataLayerGlobal({
                          type: DATALAYER_TYPE.TRACK_INDEX,
                          router: router?.pathname,
                          section: 'section-content',
                          position: 'ใต้:header',
                          data: {
                            block: '2',
                            title: `อัลบั้มรูป ${article.title}`,
                            heading: 'อัลบั้มอื่นๆ',
                            index: 1
                          }
                        });
                        localStorage.removeItem('article-data');
                        localStorage.removeItem('preview');
                      }}
                    >
                      อัลบั้มอื่นๆ
                    </a>
                  </div>
                </div>

                {/* <WidgetReadmore link={"/galleries"} /> */}
              </div>
            )}
          </div>

        </div>
        <DynamicAds position={KEY_ADS_POSITION.AD1X1} data={ads} />
                    <div className={`close-box-ads ${!closeAd ? 'close' : 'open'}`}>
                <div onClick={handleCloseBoxAd} className='close-box'>
                  <DynamicAds position={KEY_ADS_POSITION.POSTARTICLE} data={ads} />
                </div>
            </div>

        {/* <WidgetAdsIndex ads={ads} /> */}
      </GalleriesWrapper>
    </>
  );
};
export default GalleryDefault;

const GalleriesWrapper = styled.section`
h1 {
  font-size: 40px;
  color: var(--black-color);
  line-height: 1.45;
  font-weight: 600;
  @media (max-width: 767px) {
    font-size: 26px;
  }
}
.btn-articles {
      cursor: pointer;
    background-color: var(--primary-color);
    padding: 10px 30px;
    border-radius: 10px;
    color: var(--white-color);
    font-size: 18px;
    margin: 0 10px;
    width: fit-content;
    a  {
      color: var(--white-color);
    }
  }
.galleries-lastnews {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 16px;
    margin-top: 20px;
    min-height: 500px;
    .card-image {
      aspect-ratio: 1 / 1;
    }
    @media (max-width: 767px) {
      grid-template-columns: repeat(3, 1fr);
      
     .card-v{

       h3 {
         font-size: 14px;
         font-weight: 400;
         padding: 0px;
       }
     }
    }
  }
.desc  {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
  .btn-articles {
    background-color: var(--primary-color);
    padding: 10px 20px;
    border-radius: 10px;
    color: var(--white-color);
    font-size: 16px;
    a  {
      color: var(--white-color);
    }
  }
  h2 {
    font-size: 20px;
    color: #979797;
    font-weight: 400;
  
  }
}
  .container {
    max-width: 100%;
  }
  .widget-lasted {

    .slick-slide {
        padding: 0 10px;   
    }
  }
  .ads-slot {
    min-height: 300px;
    @media (max-width: 1025px) {
      min-height: 120px;
    }
  }
  .container-content {
    max-width: 1440px;
    margin: auto;
    padding: 16px;
  }
  .widget-heading {
    height: auto;
  }
  .header {
    &:before {
      height: 15px !important;
      border-radius: 0 50px 50px 0;
    }
  }
  /* .galleries-lastnews {
    @media (max-width: 768px) {
      margin-top: 14px;
      display: grid;
      grid-gap: 10px;
      grid-template-columns: repeat(2, 1fr);
    }
  } */
  .card-main {
    position: relative;
    border-radius: 0px;
    margin-bottom: 16px;
    img {
        object-fit: cover;
        aspect-ratio: 1/1;
      }
    @media (max-width: 768px) {
      margin-bottom: 0;
    }

    h3 {
      padding: 0px 15px;
    }
    .card-item {
      position: relative;
      .views-all {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        /* bottom: 0; */
        display: block;
        z-index: 1;

        span,
        svg {
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          color: #fff;
          width: 100%;
        }
        span {
          margin-top: 8px;
        }
      }
     
      &:last-child {
        position: relative;
        &:before {
          content: "";
          position: absolute;
          top: 0;
          color: #fff;
          left: 0;
          right: 0;
          bottom: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          background: rgba(0, 0, 0, 0.5);
          margin-bottom: 5px;
        }
      }
    }
    .card-list {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 10px;
      padding: 10px;
      min-height: 130px;
      img {
        width: 100%;
        height: auto;
        object-fit: cover;
      }
    }
  }
  .container {
    padding: 0;
  }
  .grid-wrapper {
    display: grid;
    align-self: center;
    grid-gap: 16px;
    grid-template-columns: 1fr;
    color: #000;
    /* @media (max-width: 768px) {
      grid-template-columns: 1fr;
    } */
  }
  .block-1 {
    padding-top: 2rem;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
  }
  .responsive-container-block {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 0 auto;
    gap: 10px;
    .img-wrapper {

        img {
          position: relative;
          aspect-ratio: 1/1;
        }
      }
  }
  .responsive-image {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 15px;
    padding: 0;
   
    @media (max-width: 767px) {
      grid-template-columns: repeat(3, 1fr);
      gap: 10px;
      .img-wrapper {
        img {
          aspect-ratio: 1/1;
        }
      }
    }
  }
  .album .img-wrapper {
    cursor: pointer;

    flex: 1 1 25%; /* Flex-grow, flex-shrink, and flex-basis for responsive layout */
    img {
      object-fit: cover;
    }
  }
  .album .img {
    width: 100%;
    max-width: 100%;
    aspect-ratio: 1/1;
    object-fit: cover;
    /* margin: 0 0 20px 0; */
    /* border-radius: 20px; */
  }

  .album .img.img-big {
    height: 50%;
    margin: 0 0 16px 0;
    aspect-ratio: 1/1;
    object-fit: cover;
  }

  .album .responsive-container-block.bg {
    position: relative;
    min-height: 220px;
    max-width: 1440px;
    margin: auto;
    display: flex;
    flex-direction: row; /* Arrange items in a row */
    flex-wrap: wrap; /* Wrap items to the next line if they exceed the container's width */
    justify-content: space-between;
    @media (max-width: 768px) {
      min-height: 200px;

    }
  }

  .album .responsive-container-block.bg {
    flex-direction: column;
  }
  .share-grid {
    display: flex;
    justify-content: flex-start;
    gap: 10px;
    margin: 20px 0;
    .text-topic {
      font-size: 20px;
      font-weight: 600;
      color: var(--black-color)
    }
    .share.item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: fit-content;
      width: fit-content;
      .--X button {
        display: flex;
        align-items: start;
        height: 43px;
      }
    }
    .x-sticky-wrapper {
      width: 36px;
      height: 36px;
      background-color: #000;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      svg {
        color: #fff;
        font-size: 18px;
      }
    }
  }
`;
